import { useForm } from "react-hook-form";
import { useState } from "react";
import { screenScrollTo } from "js/utilities";
import { useTranslation } from "react-i18next";

export default function FACStepFour({
  formStep,
  setFormStep,
  setFACFormData,
  setIsStepFiveDialogOpen,
}) {
  const {
    register: FACStepFourRegister,
    handleSubmit: FACStepFourHandleSubmit,
  } = useForm();
  const { t } = useTranslation();

  const MAXIMUMWORDCOUNT = 300;
  const [currentWordCount, setCurrentWordCount] = useState(0);

  const onSubmit = (data) => {
    screenScrollTo();
    setFormStep(5);
    setIsStepFiveDialogOpen(true);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep >= 4 && (
        <>
          <div>
            <p className="text-sm">{t("UnauthFACStep-four-subtittle")}</p>
            <hr />
            <form onSubmit={FACStepFourHandleSubmit(onSubmit)}>
              <div className="grid gap-4 grid-cols-1 lg:gap-6">
                <div>
                  <label htmlFor="ID_message">
                    {t("UnauthFACStep-four-special-character", {
                      wordCount: MAXIMUMWORDCOUNT,
                    })}
                  </label>
                  <textarea
                    id="ID_message"
                    type="text"
                    name="message"
                    className="mt-1"
                    rows="6"
                    {...FACStepFourRegister("notes", {
                      maxLength: {
                        value: MAXIMUMWORDCOUNT,
                        message: "Maximum characters exceeded.",
                      },
                      onChange: (e) => {
                        setCurrentWordCount(e.target.value.length);
                      },
                    })}
                  />
                  <span
                    className={
                      currentWordCount > MAXIMUMWORDCOUNT
                        ? "ui-input-error"
                        : ""
                    }
                  >
                    ({currentWordCount}/{MAXIMUMWORDCOUNT})
                  </span>
                </div>

                <div className="flex justify-end">
                  <button
                    className="ui-btn-secondary ui-btn-min-w mt-4"
                    type="button"
                    onClick={() => setFormStep((current) => current - 1)}
                  >
                    {t("UnauthFACStep-two-btn-1")}
                  </button>

                  <button className="ui-btn-primary ui-btn-min-w mt-4">
                    {t("UnauthFACStep-four-submit-btn")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  );
}
